import { render, staticRenderFns } from "./TheSettingsTab.vue?vue&type=template&id=65902881&"
import script from "./TheSettingsTab.vue?vue&type=script&lang=js&"
export * from "./TheSettingsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports